import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noValueTextExperiment: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noValueTextExperiment: {
		id: 'issue-field-number-readview-full.number.no-value-text-experiment',
		defaultMessage: 'Add number',
		description: 'Message when a field has no value',
	},
});
export default messages;
